<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, <b>Nexon Automation</b> 
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://www.nexonautomation.com"
                class="nav-link text-muted"
                target="_blank"
                >Nexon Automation</a
              >
            </li>
            <li class="nav-item">
              <router-link to="/documentation" class="nav-link text-muted">
                Documentación
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/user-manual" class="nav-link text-muted">
                Manual de usuario
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
